import { PortableTextTypeComponentProps } from "@portabletext/react";
import ImageComponent from "next/image";
import { imageLoader } from "@/lib/sanity/client";
import { useState } from "react";
import { InlineImage, ContainerImage } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Image = ImageComponent as any;

export type RichTextImageProps = PortableTextTypeComponentProps<{
  type: string;
  width: number;
  height: number;
  alt: string;
  image: {
    asset: {
      url: string;
    };
  };
}>;

const RichTextImage: React.FC<RichTextImageProps> = (props) => {
  const [loaded, setLoaded] = useState(false);
  const { image, type, width, height, alt = "" } = props.value;

  if (type === "inline") {
    return (
      <InlineImage $hasLoaded={loaded}>
        {image?.asset?.url && (
          <Image
            src={image.asset.url}
            width={width}
            height={height}
            alt={alt}
            loader={imageLoader}
            onLoadingComplete={() => setLoaded(true)}
          />
        )}
      </InlineImage>
    );
  }

  return (
    <ContainerImage $hasLoaded={loaded}>
      {image?.asset?.url && (
        <Image
          src={image.asset.url}
          layout="fill"
          objectFit="cover"
          alt={alt}
          loader={imageLoader}
          onLoadingComplete={() => setLoaded(true)}
          sizes="100vw"
        />
      )}
    </ContainerImage>
  );
};

export default RichTextImage;
